
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"466.667","height":"453.333","viewBox":"0 0 350 340"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M315.8 17.4c-2.4.9-7.5 5.2-15 12.8-29.5 29.8-73.1 53.5-121.9 66.3l-12.5 3.2-4.1-3.8c-2.2-2.1-5.9-4.3-8.2-4.9-2.8-.7-18.5-1-49.3-.8-44.9.3-45.3.3-49.5 2.6-2.4 1.2-5.5 4.1-7 6.4-2.4 3.6-2.8 5.4-3.1 12.8l-.4 8.7-6.2.5c-10 .8-17.7 6-21 14-2.3 5.5-2.3 64.1 0 69.6C21 212.9 30.7 219 40.5 219H45v6.7c0 12.2 6.8 20.4 18 21.9l4.6.6 5.4 22.7c6.7 28.6 7.8 31.5 13.7 37.3 7.8 7.7 12.2 9.1 29.8 9.6 17.3.5 25.3-.7 30.7-4.4 4.6-3.2 8.8-11.2 8.8-16.8 0-2.3-2.5-14-5.4-26.1l-5.3-22 2.6-.3c6.3-.8 10.6-2.6 14.4-6.2l4.2-3.8 9.5 2.4c49.6 12.7 95.2 37.2 124.5 66.9 12.2 12.4 13.8 13.5 19 13.5 5.4 0 9.4-2.5 11.6-7.3 1.8-4.1 1.9-8.8 1.9-144.7 0-135.9-.1-140.6-1.9-144.7-2.9-6.2-9.2-9-15.3-6.9zM313 169.1v122.1l-6.7-6.2c-17.4-16.3-44.7-33.4-73.5-46.1-12.9-5.7-37.8-14.3-48.8-16.9-7.6-1.7-10.1-2.8-12.2-5.1L169 214v-44.5c0-30.4.3-45.2 1.1-46.8 1.5-3.2 3.2-4 17-7.6 26.6-7 57.6-20.1 81.3-34.4 15.9-9.6 33.7-22.8 41-30.6 1.7-1.7 3.1-3.1 3.3-3.1.2 0 .3 55 .3 122.1zm-164-.6V227H65V110h84v58.5zM43.4 141.6c1.4.5 1.6 4 1.6 28.4 0 27.3 0 27.9-2.1 28.5-1.1.4-3.1.4-4.5.1L36 198v-27.9c0-21.4.3-28.1 1.3-28.4 1.8-.8 4.3-.8 6.1-.1zm86.5 129.1c3 12.6 5.6 23.6 5.9 24.5.4 1.7-.8 1.8-15.6 1.8-15.2 0-16.2-.1-18.7-2.3-2.6-2.2-3.4-5.1-12.9-45-.4-1.6 1-1.7 17.8-1.7h18.2l5.3 22.7z"}})])
          )
        }
      }
    